import cn from "classnames";
import BookShow from "components/shared/book/show";
import Loader from "components/shared/loader";
import { serializeReq } from "helpers/form";
import { paths } from "helpers/paths";
import { connect, generatedActions, viewDispatchToProps, viewStateToProps } from "helpers/redux";
import pick from "lodash/pick";
import React from "react";
import { Link } from "react-router-dom";
import { getCatalogInfo } from "sources/books/dictionaries";
import { applyOrganizationCatalog } from "sources/catalogs";
import { config, initialState } from "../formConfig";

class ShowOrganizationCatalog extends BookShow {
    get dropdActions() {
        return [];
    }

    getItem = ({ source, match }) => {
        const defParams = { isLoading: false, isValid: true, shouldUpdate: false };
        source.getItem(match.params).then((data) => {
            getCatalogInfo(data.catalogPropertyName).then((info) => {
                this.setState({
                    data: { ...info, ...data },
                    initial: { ...info, ...data },
                    ...defParams,
                });
            });
        });
    };

    reset = () => {
        this.setState({ data: this.state.initial, shouldUpdate: false });
    };

    update = (callback) => {
        callback().then(() => this.getItem(this.props));
    };

    apply = () => {
        const { isLoading, shouldUpdate, ...state } = this.state;
        const fields = pick(state.data, Object.keys(this.props.config));
        if (!isLoading && shouldUpdate) {
            if (this.isValidForm(fields)) {
                this.setState({ isLoading: true, isValid: true });
                return applyOrganizationCatalog(serializeReq(fields)).then((res) =>
                    res ? this.update(this.props.getDictionaries) : this.setState({ isLoading: false, isValid: false }),
                );
            }
            this.setState({ isValid: false });
        }
    };

    renderButton = () => {
        const { canEditBooks } = this.props;
        const cname = cn("btn btn-brand btn-sm", {
            disabled: !this.state.shouldUpdate || this.state.data.externalId === "ExcessMileageReasonType",
        });
        return (
            <div className="panel__row panel__row--button">
                <Link
                    className="btn btn-sm btn-link"
                    to={paths.organizationCatalogItems(this.state.data.catalogPropertyName)}
                >
                    Список элементов справочника
                </Link>
                {canEditBooks && (
                    <>
                        {this.state.shouldUpdate && (
                            <div className="btn btn-secondary btn-sm mr-2" onClick={this.reset}>
                                Сбросить
                            </div>
                        )}
                        <div className={cname} onClick={this.apply}>
                            Обновить
                        </div>
                    </>
                )}
            </div>
        );
    };

    renderBody = () => {
        const { config } = this.props;
        if (this.state.isLoading) {
            return <Loader prefix="absolute-center" />;
        }
        const disabled = this.state.data.externalId === "ExcessMileageReasonType";
        return (
            <>
                {this.renderField({ ...config.displayName, disabled })}
                {this.renderField({ ...config.description, disabled })}
                {this.renderField({ ...config.externalId, disabled })}
                {this.renderSelect({ ...config.entityType, disabled })}
                {this.renderButton()}
            </>
        );
    };
}

const ConfiguredShow = (props) => <ShowOrganizationCatalog {...props} config={config} initialState={initialState} />;

const customDispatch = (dispatch) => {
    return {
        ...viewDispatchToProps(dispatch, generatedActions.organizationcatalogs),
        getDictionaries: () => dispatch(generatedActions.dictionaries.index()),
    };
};

export default connect(viewStateToProps, customDispatch)(ConfiguredShow);
